export const worldCurrencies = [
    // A
    { country: "Afghanistan", currency: "Afghan Afghani", code: "AFN", symbol: "؋" },
    { country: "Albania", currency: "Albanian Lek", code: "ALL", symbol: "L" },
    { country: "Algeria", currency: "Algerian Dinar", code: "DZD", symbol: "د.ج" },
    { country: "Andorra", currency: "Euro", code: "EUR", symbol: "€" },
    { country: "Angola", currency: "Angolan Kwanza", code: "AOA", symbol: "Kz" },
    { country: "Antigua and Barbuda", currency: "East Caribbean Dollar", code: "XCD", symbol: "$" },
    { country: "Argentina", currency: "Argentine Peso", code: "ARS", symbol: "$" },
    { country: "Armenia", currency: "Armenian Dram", code: "AMD", symbol: "֏" },
    { country: "Australia", currency: "Australian Dollar", code: "AUD", symbol: "$" },
    { country: "Austria", currency: "Euro", code: "EUR", symbol: "€" },
    { country: "Azerbaijan", currency: "Azerbaijani Manat", code: "AZN", symbol: "₼" },

    // B
    { country: "Bahamas", currency: "Bahamian Dollar", code: "BSD", symbol: "$" },
    { country: "Bahrain", currency: "Bahraini Dinar", code: "BHD", symbol: ".د.ب" },
    { country: "Bangladesh", currency: "Bangladeshi Taka", code: "BDT", symbol: "৳" },
    { country: "Barbados", currency: "Barbadian Dollar", code: "BBD", symbol: "$" },
    { country: "Belarus", currency: "Belarusian Ruble", code: "BYN", symbol: "Br" },
    { country: "Belgium", currency: "Euro", code: "EUR", symbol: "€" },
    { country: "Belize", currency: "Belize Dollar", code: "BZD", symbol: "$" },
    { country: "Benin", currency: "West African CFA Franc", code: "XOF", symbol: "CFA" },
    { country: "Bhutan", currency: "Bhutanese Ngultrum", code: "BTN", symbol: "Nu." },
    { country: "Bolivia", currency: "Bolivian Boliviano", code: "BOB", symbol: "Bs." },
    { country: "Bosnia and Herzegovina", currency: "Bosnia-Herzegovina Convertible Mark", code: "BAM", symbol: "KM" },
    { country: "Botswana", currency: "Botswana Pula", code: "BWP", symbol: "P" },
    { country: "Brazil", currency: "Brazilian Real", code: "BRL", symbol: "R$" },
    { country: "Brunei", currency: "Brunei Dollar", code: "BND", symbol: "$" },
    { country: "Bulgaria", currency: "Bulgarian Lev", code: "BGN", symbol: "лв" },
    { country: "Burkina Faso", currency: "West African CFA Franc", code: "XOF", symbol: "CFA" },
    { country: "Burundi", currency: "Burundian Franc", code: "BIF", symbol: "FBu" },

    // C
    { country: "Cabo Verde", currency: "Cape Verdean Escudo", code: "CVE", symbol: "$" },
    { country: "Cambodia", currency: "Cambodian Riel", code: "KHR", symbol: "៛" },
    { country: "Cameroon", currency: "Central African CFA Franc", code: "XAF", symbol: "FCFA" },
    { country: "Canada", currency: "Canadian Dollar", code: "CAD", symbol: "$" },
    { country: "Central African Republic", currency: "Central African CFA Franc", code: "XAF", symbol: "FCFA" },
    { country: "Chad", currency: "Central African CFA Franc", code: "XAF", symbol: "FCFA" },
    { country: "Chile", currency: "Chilean Peso", code: "CLP", symbol: "$" },
    { country: "China", currency: "Chinese Yuan", code: "CNY", symbol: "¥" },
    { country: "Colombia", currency: "Colombian Peso", code: "COP", symbol: "$" },
    { country: "Comoros", currency: "Comorian Franc", code: "KMF", symbol: "CF" },
    { country: "Congo (DRC)", currency: "Congolese Franc", code: "CDF", symbol: "FC" },
    { country: "Congo (Republic)", currency: "Central African CFA Franc", code: "XAF", symbol: "FCFA" },
    { country: "Costa Rica", currency: "Costa Rican Colón", code: "CRC", symbol: "₡" },
    { country: "Côte d'Ivoire", currency: "West African CFA Franc", code: "XOF", symbol: "CFA" },
    { country: "Croatia", currency: "Croatian Kuna", code: "HRK", symbol: "kn" },
    { country: "Cuba", currency: "Cuban Peso", code: "CUP", symbol: "$" },
    { country: "Cyprus", currency: "Euro", code: "EUR", symbol: "€" },
    { country: "Czech Republic", currency: "Czech Koruna", code: "CZK", symbol: "Kč" },

    // D
    { country: "Denmark", currency: "Danish Krone", code: "DKK", symbol: "kr" },
    { country: "Djibouti", currency: "Djiboutian Franc", code: "DJF", symbol: "Fdj" },
    { country: "Dominica", currency: "East Caribbean Dollar", code: "XCD", symbol: "$" },
    { country: "Dominican Republic", currency: "Dominican Peso", code: "DOP", symbol: "$" },

    // E
    { country: "Ecuador", currency: "US Dollar", code: "USD", symbol: "$" },
    { country: "Egypt", currency: "Egyptian Pound", code: "EGP", symbol: "£" },
    { country: "El Salvador", currency: "US Dollar", code: "USD", symbol: "$" },
    { country: "Equatorial Guinea", currency: "Central African CFA Franc", code: "XAF", symbol: "FCFA" },
    { country: "Eritrea", currency: "Eritrean Nakfa", code: "ERN", symbol: "Nfk" },
    { country: "Estonia", currency: "Euro", code: "EUR", symbol: "€" },
    { country: "Eswatini", currency: "Swazi Lilangeni", code: "SZL", symbol: "L" },
    { country: "Ethiopia", currency: "Ethiopian Birr", code: "ETB", symbol: "Br" },

    // F
    { country: "Fiji", currency: "Fijian Dollar", code: "FJD", symbol: "$" },
    { country: "Finland", currency: "Euro", code: "EUR", symbol: "€" },
    { country: "France", currency: "Euro", code: "EUR", symbol: "€" },

    // G
    { country: "Gabon", currency: "Central African CFA Franc", code: "XAF", symbol: "FCFA" },
    { country: "Gambia", currency: "Gambian Dalasi", code: "GMD", symbol: "D" },
    { country: "Georgia", currency: "Georgian Lari", code: "GEL", symbol: "₾" },
    { country: "Germany", currency: "Euro", code: "EUR", symbol: "€" },
    { country: "Ghana", currency: "Ghanaian Cedi", code: "GHS", symbol: "₵" },
    { country: "Greece", currency: "Euro", code: "EUR", symbol: "€" },
    { country: "Grenada", currency: "East Caribbean Dollar", code: "XCD", symbol: "$" },
    { country: "Guatemala", currency: "Guatemalan Quetzal", code: "GTQ", symbol: "Q" },
    { country: "Guinea", currency: "Guinean Franc", code: "GNF", symbol: "FG" },
    { country: "Guinea-Bissau", currency: "West African CFA Franc", code: "XOF", symbol: "CFA" },
    { country: "Guyana", currency: "Guyanese Dollar", code: "GYD", symbol: "$" },

    // H
    { country: "Haiti", currency: "Haitian Gourde", code: "HTG", symbol: "G" },
    { country: "Honduras", currency: "Honduran Lempira", code: "HNL", symbol: "L" },
    { country: "Hong Kong", currency: "Hong Kong Dollar", code: "HKD", symbol: "$" },
    { country: "Hungary", currency: "Hungarian Forint", code: "HUF", symbol: "Ft" },

    // I
    { country: "Iceland", currency: "Icelandic Króna", code: "ISK", symbol: "kr" },
    { country: "India", currency: "Indian Rupee", code: "INR", symbol: "₹" },
    { country: "Indonesia", currency: "Indonesian Rupiah", code: "IDR", symbol: "Rp" },
    { country: "Iran", currency: "Iranian Rial", code: "IRR", symbol: "﷼" },
    { country: "Iraq", currency: "Iraqi Dinar", code: "IQD", symbol: "ع.د" },
    { country: "Ireland", currency: "Euro", code: "EUR", symbol: "€" },
    { country: "Israel", currency: "Israeli New Shekel", code: "ILS", symbol: "₪" },
    { country: "Italy", currency: "Euro", code: "EUR", symbol: "€" },

    // J
    { country: "Jamaica", currency: "Jamaican Dollar", code: "JMD", symbol: "$" },
    { country: "Japan", currency: "Japanese Yen", code: "JPY", symbol: "¥" },
    { country: "Jordan", currency: "Jordanian Dinar", code: "JOD", symbol: "د.ا" },

    // K
    { country: "Kazakhstan", currency: "Kazakhstani Tenge", code: "KZT", symbol: "₸" },
    { country: "Kenya", currency: "Kenyan Shilling", code: "KES", symbol: "KSh" },
    { country: "Kiribati", currency: "Australian Dollar", code: "AUD", symbol: "$" },
    { country: "Korea (North)", currency: "North Korean Won", code: "KPW", symbol: "₩" },
    { country: "Korea (South)", currency: "South Korean Won", code: "KRW", symbol: "₩" },
    { country: "Kosovo", currency: "Euro", code: "EUR", symbol: "€" },
    { country: "Kuwait", currency: "Kuwaiti Dinar", code: "KWD", symbol: "د.ك" },
    { country: "Kyrgyzstan", currency: "Kyrgyzstani Som", code: "KGS", symbol: "с" },

    // L
    { country: "Laos", currency: "Lao Kip", code: "LAK", symbol: "₭" },
    { country: "Latvia", currency: "Euro", code: "EUR", symbol: "€" },
    { country: "Lebanon", currency: "Lebanese Pound", code: "LBP", symbol: "ل.ل" },
    { country: "Lesotho", currency: "Lesotho Loti", code: "LSL", symbol: "L" },
    { country: "Liberia", currency: "Liberian Dollar", code: "LRD", symbol: "$" },
    { country: "Libya", currency: "Libyan Dinar", code: "LYD", symbol: "ل.د" },
    { country: "Liechtenstein", currency: "Swiss Franc", code: "CHF", symbol: "CHF" },
    { country: "Lithuania", currency: "Euro", code: "EUR", symbol: "€" },
    { country: "Luxembourg", currency: "Euro", code: "EUR", symbol: "€" },

    // M
    { country: "Macau", currency: "Macanese Pataca", code: "MOP", symbol: "MOP$" },
    { country: "Madagascar", currency: "Malagasy Ariary", code: "MGA", symbol: "Ar" },
    { country: "Malawi", currency: "Malawian Kwacha", code: "MWK", symbol: "MK" },
    { country: "Malaysia", currency: "Malaysian Ringgit", code: "MYR", symbol: "RM" },
    { country: "Maldives", currency: "Maldivian Rufiyaa", code: "MVR", symbol: "Rf" },
    { country: "Mali", currency: "West African CFA Franc", code: "XOF", symbol: "CFA" },
    { country: "Malta", currency: "Euro", code: "EUR", symbol: "€" },
    { country: "Marshall Islands", currency: "US Dollar", code: "USD", symbol: "$" },
    { country: "Mauritania", currency: "Mauritanian Ouguiya", code: "MRU", symbol: "UM" },
    { country: "Mauritius", currency: "Mauritian Rupee", code: "MUR", symbol: "₨" },
    { country: "Mexico", currency: "Mexican Peso", code: "MXN", symbol: "$" },
    { country: "Micronesia", currency: "US Dollar", code: "USD", symbol: "$" },
    { country: "Moldova", currency: "Moldovan Leu", code: "MDL", symbol: "L" },
    { country: "Monaco", currency: "Euro", code: "EUR", symbol: "€" },
    { country: "Mongolia", currency: "Mongolian Tögrög", code: "MNT", symbol: "₮" },
    { country: "Montenegro", currency: "Euro", code: "EUR", symbol: "€" },
    { country: "Morocco", currency: "Moroccan Dirham", code: "MAD", symbol: "د.م." },
    { country: "Mozambique", currency: "Mozambican Metical", code: "MZN", symbol: "MT" },
    { country: "Myanmar", currency: "Burmese Kyat", code: "MMK", symbol: "K" },

    // N
    { country: "Namibia", currency: "Namibian Dollar", code: "NAD", symbol: "$" },
    { country: "Nauru", currency: "Australian Dollar", code: "AUD", symbol: "$" },
    { country: "Nepal", currency: "Nepalese Rupee", code: "NPR", symbol: "₨" },
    { country: "Netherlands", currency: "Euro", code: "EUR", symbol: "€" },
    { country: "New Zealand", currency: "New Zealand Dollar", code: "NZD", symbol: "$" },
    { country: "Nicaragua", currency: "Nicaraguan Córdoba", code: "NIO", symbol: "C$" },
    { country: "Niger", currency: "West African CFA Franc", code: "XOF", symbol: "CFA" },
    { country: "Nigeria", currency: "Nigerian Naira", code: "NGN", symbol: "₦" },
    { country: "North Korea", currency: "North Korean Won", code: "KPW", symbol: "₩" },
    { country: "North Macedonia", currency: "Macedonian Denar", code: "MKD", symbol: "ден" },
    { country: "Norway", currency: "Norwegian Krone", code: "NOK", symbol: "kr" },

    // O
    { country: "Oman", currency: "Omani Rial", code: "OMR", symbol: "ر.ع." },

    // P
    { country: "Pakistan", currency: "Pakistani Rupee", code: "PKR", symbol: "₨" },
    { country: "Palau", currency: "US Dollar", code: "USD", symbol: "$" },
    { country: "Panama", currency: "Panamanian Balboa", code: "PAB", symbol: "B/." },
    { country: "Papua New Guinea", currency: "Papua New Guinean Kina", code: "PGK", symbol: "K" },
    { country: "Paraguay", currency: "Paraguayan Guarani", code: "PYG", symbol: "₲" },
    { country: "Peru", currency: "Peruvian Sol", code: "PEN", symbol: "S/." },
    { country: "Philippines", currency: "Philippine Peso", code: "PHP", symbol: "₱" },
    { country: "Poland", currency: "Polish Złoty", code: "PLN", symbol: "zł" },
    { country: "Portugal", currency: "Euro", code: "EUR", symbol: "€" },

    // Q
    { country: "Qatar", currency: "Qatari Riyal", code: "QAR", symbol: "ر.ق" },

    // R
    { country: "Romania", currency: "Romanian Leu", code: "RON", symbol: "lei" },
    { country: "Russia", currency: "Russian Ruble", code: "RUB", symbol: "₽" },
    { country: "Rwanda", currency: "Rwandan Franc", code: "RWF", symbol: "FRw" },

    // S
    { country: "Saint Kitts and Nevis", currency: "East Caribbean Dollar", code: "XCD", symbol: "$" },
    { country: "Saint Lucia", currency: "East Caribbean Dollar", code: "XCD", symbol: "$" },
    { country: "Saint Vincent and the Grenadines", currency: "East Caribbean Dollar", code: "XCD", symbol: "$" },
    { country: "Samoa", currency: "Samoan Tala", code: "WST", symbol: "T" },
    { country: "San Marino", currency: "Euro", code: "EUR", symbol: "€" },
    { country: "Sao Tome and Principe", currency: "São Tomé and Príncipe Dobra", code: "STN", symbol: "Db" },
    { country: "Saudi Arabia", currency: "Saudi Riyal", code: "SAR", symbol: "ر.س" },
    { country: "Senegal", currency: "West African CFA Franc", code: "XOF", symbol: "CFA" },
    { country: "Serbia", currency: "Serbian Dinar", code: "RSD", symbol: "дин" },
    { country: "Seychelles", currency: "Seychellois Rupee", code: "SCR", symbol: "₨" },
    { country: "Sierra Leone", currency: "Sierra Leonean Leone", code: "SLL", symbol: "Le" },
    { country: "Singapore", currency: "Singapore Dollar", code: "SGD", symbol: "$" },
    { country: "Slovakia", currency: "Euro", code: "EUR", symbol: "€" },
    { country: "Slovenia", currency: "Euro", code: "EUR", symbol: "€" },
    { country: "Solomon Islands", currency: "Solomon Islands Dollar", code: "SBD", symbol: "$" },
    { country: "Somalia", currency: "Somali Shilling", code: "SOS", symbol: "Sh" },
    { country: "South Africa", currency: "South African Rand", code: "ZAR", symbol: "R" },
    { country: "South Sudan", currency: "South Sudanese Pound", code: "SSP", symbol: "£" },
    { country: "Spain", currency: "Euro", code: "EUR", symbol: "€" },
    { country: "Sri Lanka", currency: "Sri Lankan Rupee", code: "LKR", symbol: "Rs" },
    { country: "Sudan", currency: "Sudanese Pound", code: "SDG", symbol: "ج.س." },
    { country: "Suriname", currency: "Surinamese Dollar", code: "SRD", symbol: "$" },
    { country: "Sweden", currency: "Swedish Krona", code: "SEK", symbol: "kr" },
    { country: "Switzerland", currency: "Swiss Franc", code: "CHF", symbol: "CHF" },
    { country: "Syria", currency: "Syrian Pound", code: "SYP", symbol: "£" },

    // T
    { country: "Taiwan", currency: "New Taiwan Dollar", code: "TWD", symbol: "NT$" },
    { country: "Tajikistan", currency: "Tajikistani Somoni", code: "TJS", symbol: "ЅМ" },
    { country: "Tanzania", currency: "Tanzanian Shilling", code: "TZS", symbol: "TSh" },
    { country: "Thailand", currency: "Thai Baht", code: "THB", symbol: "฿" },
    { country: "Timor-Leste", currency: "US Dollar", code: "USD", symbol: "$" },
    { country: "Togo", currency: "West African CFA Franc", code: "XOF", symbol: "CFA" },
    { country: "Tonga", currency: "Tongan Paʻanga", code: "TOP", symbol: "T$" },
    { country: "Trinidad and Tobago", currency: "Trinidad and Tobago Dollar", code: "TTD", symbol: "$" },
    { country: "Tunisia", currency: "Tunisian Dinar", code: "TND", symbol: "د.ت" },
    { country: "Turkey", currency: "Turkish Lira", code: "TRY", symbol: "₺" },
    { country: "Turkmenistan", currency: "Turkmenistani Manat", code: "TMT", symbol: "m" },
    { country: "Tuvalu", currency: "Australian Dollar", code: "AUD", symbol: "$" },

    // U
    { country: "Uganda", currency: "Ugandan Shilling", code: "UGX", symbol: "USh" },
    { country: "Ukraine", currency: "Ukrainian Hryvnia", code: "UAH", symbol: "₴" },
    { country: "United Arab Emirates", currency: "UAE Dirham", code: "AED", symbol: "د.إ" },
    { country: "United Kingdom", currency: "British Pound Sterling", code: "GBP", symbol: "£" },
    { country: "United States", currency: "US Dollar", code: "USD", symbol: "$" },
    { country: "Uruguay", currency: "Uruguayan Peso", code: "UYU", symbol: "$" },
    { country: "Uzbekistan", currency: "Uzbekistani Som", code: "UZS", symbol: "so'm" },

    // V
    { country: "Vanuatu", currency: "Vanuatu Vatu", code: "VUV", symbol: "Vt" },
    { country: "Vatican City", currency: "Euro", code: "EUR", symbol: "€" },
    { country: "Venezuela", currency: "Venezuelan Bolívar", code: "VES", symbol: "Bs." },
    { country: "Vietnam", currency: "Vietnamese Đồng", code: "VND", symbol: "₫" },

    // Y
    { country: "Yemen", currency: "Yemeni Rial", code: "YER", symbol: "﷼" },

    // Z
    { country: "Zambia", currency: "Zambian Kwacha", code: "ZMW", symbol: "ZK" },
    { country: "Zimbabwe", currency: "Zimbabwean Dollar", code: "ZWL", symbol: "$" }
];